export const SDI_INTEGRATIONS_QUERY = 'sdi-integrations';
export const SDI_INTEGRATIONS_HISTORY_QUERY = 'sdi-run-history';
export const SDI_INTEGRATIONS_API_URL = process.env.REACT_APP_API_SERVICE_URL;
